import {
  EmailMessage,
  EmailTemplateEditorInfo,
  EmployeeProfile,
  ExitCommentTypes,
  ExitEmailMessage,
  ExitRequest,
  ExitRequestActivity,
  ImmigrationDocumentVisaMappingDTO,
  LookupField, PBProfile
} from "./api.gen";
import { Injectable } from "@angular/core";
import {
  NgbModal,
  NgbModalConfig,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { AlertComponent } from "../shared/alert/alert.component";
import { ArCommentComponent } from "../shared/ar-comment/ar-comment.component";
import { CommentComponent } from "../shared/comment/comment.component";
import { CommentTypes } from "../shared/comment-types";
import { DepFlightBookingComponent } from "../pre-boarding/dep-flight-booking/dep-flight-booking/dep-flight-booking.component";
import {
  CandidateProfile,
  Activity,
  ImmigrationCandidate,
  ImmigrationCommentTypes,
  FilterParams,
  ImmigrationProfile,
  ImmigrationProfileActivity,
  UserInfo,
} from "src/app/core/api.gen";
import { EmailComponent } from "../shared/email/email.component";
import { nullSafe } from "../utils";
import { TimeoutWindowComponent } from "../shared/timeout-window/timeout-window.component";
import { HistoryComponent } from "../shared/history/history.component";
import { PdfViewerComponent } from "../shared/pdf-viewer/pdf-viewer.component";
import { ImageViewerComponent } from "../shared/image-viewer/image-viewer.component";
import { LogDetailsComponent } from "../admin/components/log-view/log-details/log-details.component";
import { DateRangeFilterComponent } from "../shared/date-range-filter/date-range-filter.component";
import { ImmigrationCommentsComponent } from "../shared/immigration-comments/immigration-comments.component";
import { ImmigrationEmailComponent } from "../shared/immigration-email/immigration-email.component";
import { UserEditorComponent } from "../shared/user-editor/user-editor.component";
import { TemplateSelectorComponent } from "../template-generator/template-selector/template-selector/template-selector.component";
import { TaskAmendmentEditComponent } from "../task-amendment/task-amendment-edit/task-amendment-edit.component";
import { ConfigurableMailComponent } from "../shared/configurable-mail/configurable-mail.component";
import { MilestoneBasicComponent } from "../shared/milestone-basic/milestone-basic.component";
import { LookupTypeAmendmentEditComponent } from "../lookup-type- amendment/lookup-type-amendment/lookup-type-amendment-edit/lookup-type-amendment-edit/lookup-type-amendment-edit.component";
import { UserRequestComponent } from "../user/components/user-request/user-request.component";
import { ConfigurableCommentComponent } from "../shared/configurable-comment/configurable-comment.component";
import { Observable } from "rxjs";
import { ControlView } from "../shared/configurable-mail/general-mail-model";
import { ExitTaskAmendEditComponent } from "../exit-task-amendment/exit-task-amend-edit/exit-task-amend-edit.component";
import { AdditionalDocRequestComponent } from "../shared/additional-doc-request/additional-doc-request.component";
import { ImmigrationRequestcopydialogComponent } from "../shared/immigration-requestcopydialog/immigration-requestcopydialog.component";
import { NotificationGridComponent } from "../shared/notification-grid/notification-grid.component";
import { CandidateAdditionDocRequestComponent } from "../shared/candidate-addition-doc-request/candidate-addition-doc-request.component";
import { CommentConfirmationComponent } from "../shared/comment-confirmation/comment-confirmation.component";
import { MilestoneComponent } from "../shared/milestone/milestone.component";
import { ExitBulkUploadComponent } from "../shared/exit-bulk-upload/exit-bulk-upload.component";
import { BulkUploadConfirmationComponent } from "../shared/bulk-upload-confirmation/bulk-upload-confirmation.component";
import { EmpAdditionalDocRequestComponent } from "../shared/emp-additional-doc-request/emp-additional-doc-request.component";
import { ImmDocumentVisamappingEditComponent } from "../imm-document-visamapping/imm-document-visamapping-edit/imm-document-visamapping-edit.component";
import { CandidatePendingDocRequestComponent } from "../shared/candidate-pending-doc-request/candidate-pending-doc-request.component";
import { TimelineReportComponent } from "../shared/timeline-report/timeline-report.component";
import { PendingactionReportComponent } from "../shared/pendingaction-report/pendingaction-report.component";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(config: NgbModalConfig, private modalService: NgbModal) {
    config.backdrop = "static";
    // config.keyboard = false;
  }

  public showConfirmationBox(
    header: string,
    content: string,
    onOk: Function,
    onCancel?: Function,
    isShareDocs = false,
    isOkCancel = true
  ) {
    const alertRef = this.modalService.open(AlertComponent);
    alertRef.componentInstance.header = header;
    alertRef.componentInstance.content = content;
    alertRef.componentInstance.isShareDocs = isShareDocs;
    alertRef.componentInstance.isOkCancel = isOkCancel;
    alertRef.result.then(
      (resp) => {
        if (resp && onOk) {
          onOk();
        } else {
          if (onCancel) {
            onCancel();
          }
        }
      },
      (dismiss) => {
        if (onCancel) {
          onCancel();
        }
      }
    );
  }
  public showCommentConfirmationBox(
    header: string,
    content: string,
    onOk: Function,
    onCancel?: Function
  ) {
    const alertRef = this.modalService.open(CommentConfirmationComponent);
    alertRef.componentInstance.header = header;
    alertRef.componentInstance.content = content;
    alertRef.result.then(
      (resp) => {
        if (resp && onOk) {
          onOk();
        }
      },
      (dismiss) => {
        // Check if the dismiss event is due to 'No' button click or modal close
        if (dismiss === 'noButtonClick' && onCancel) {
          onCancel();
        }
        // Do nothing if the modal is closed without clicking 'No' button
      }
    );
  }
  

  public showApprovalBox(onApprove: (comment: any) => void) {
    this.showARBox(onApprove, true);
  }

  public showApprovalBoxWithComments(
    autoPopComments: string,
    onApprove: (comment: any) => void
  ) {
    this.showARBox(onApprove, true, null, autoPopComments);
  }

  //public getApprejBox(header, message, isApprove, onSubmit: (comment: string) => void) {
  //  const confirmationBox = this.modalService.open(ArCommentComponent);
  //  confirmationBox.componentInstance.isApprove = isApprove;
  //  if (header) {
  //    confirmationBox.componentInstance.header = header;
  //  }
  //  if (message) {
  //    confirmationBox.componentInstance.message = message;
  //  }
  //  confirmationBox.result.then(closeParam => {
  //    if (!isApprove && nullSafe<number>(() => closeParam.trim().length, -1) <= 0) {
  //      return;
  //    }

  //    if (onSubmit) {
  //      onSubmit(closeParam);
  //    }
  //  }, dismiss => {

  //  });
  //}

  public showRejectionBox(
    onReject: (returnParams: any) => void,
    checkBoxLabel?: string
  ) {
    this.showARBox(onReject, false, checkBoxLabel);
  }

  private showARBox(
    onSubmit: (returnParams: string) => void,
    isApproval: boolean,
    checkBoxLabel?: string,
    autoPopComments: string = ""
  ) {
    const confirmationBox = this.modalService.open(ArCommentComponent);
    confirmationBox.componentInstance.isApprove = isApproval;
    confirmationBox.componentInstance.checkBoxLabel = checkBoxLabel;
    confirmationBox.componentInstance.comment = autoPopComments;
    confirmationBox.result.then(
      (closeParam) => {
        if (
          !isApproval &&
          nullSafe<number>(() => closeParam.Comment.trim().length, -1) <= 0
        ) {
          return;
        }

        if (onSubmit) {
          onSubmit(closeParam);
        }
      },
      (dismiss) => {}
    );
  }
  public showNoofCopyDialog(
    onSubmit: (returnParams: any) => void,
    noofcopies: number = 1
  ) {
    const confirmationBox = this.modalService.open(
      ImmigrationRequestcopydialogComponent
    );
    confirmationBox.componentInstance.noofcopies = noofcopies;
    confirmationBox.result.then(
      (closeParam) => {
        if (nullSafe<number>(() => closeParam.noofCopies) <= 0) {
          return;
        }

        if (onSubmit) {
          onSubmit(closeParam);
        }
      },
      (dismiss) => {}
    );
  }
  public showImApproveBox(
    isCommentMandatory: boolean,
    onSubmit: (comment: any) => void
  ) {
    this.showARBox(onSubmit, isCommentMandatory);
  }

  public showCommentBox(profile: CandidateProfile, readonly?: boolean) {
    const comment = this.modalService.open(CommentComponent);
    comment.componentInstance.readonly = readonly;
    comment.componentInstance.commentType = CommentTypes.Preboarding;
    comment.componentInstance.candidate = profile;
  }

  public ImmCommentBox(
    candidate: ImmigrationCandidate,
    type: ImmigrationCommentTypes,
    readonly?: boolean
  ) {
    const comment = this.modalService.open(ImmigrationCommentsComponent);
    comment.componentInstance.readonly = readonly;
    comment.componentInstance.commentType = type;
    comment.componentInstance.profileId = candidate.profile.id;
    comment.componentInstance.profileStatusId = candidate.profile.status.id;
  }

  public showActivityCommentBox(
    activity: Activity,
    profile: CandidateProfile,
    onSend: Function,
    readonly?: boolean
  ) {
    const comment = this.modalService.open(CommentComponent);
    comment.componentInstance.readonly = readonly;
    comment.componentInstance.commentType = CommentTypes.Preboarding;
    comment.componentInstance.candidate = profile;
    comment.componentInstance.activity = activity;
    comment.componentInstance.onSubmit = onSend;
    comment.componentInstance.IsActivityComment = true;
  }

  public showEmailPreview(
    activity: Activity,
    candidate: CandidateProfile,
    onSend: Function,
    immigrationCaseType?: number
  ) {
    const email = this.modalService.open(EmailComponent);
    email.componentInstance.activity = activity;
    email.componentInstance.onSubmit = onSend;
    email.componentInstance.candidate = candidate;
    email.componentInstance.immigrationCaseTypeId = immigrationCaseType;
  }

  public showImmigrationEmailPreview(
    activity: ImmigrationProfileActivity,
    Immcandidate: ImmigrationProfile,
    onSend: Function
  ) {
    const email = this.modalService.open(ImmigrationEmailComponent);
    email.componentInstance.activity = activity;
    email.componentInstance.onSubmit = onSend;
    //email.componentInstance.immigrationCandidate = Immcandidate;
  }

  public showAdditionalDocReq(
    profile: ImmigrationProfile,
    visaType,
    countryType,
    onSubmit: (profile, reqlist, requestorEmail) => void
  ) {
    const additionalDocs = this.modalService.open(
      AdditionalDocRequestComponent
    );
    additionalDocs.componentInstance.profile = profile;
    additionalDocs.componentInstance.visaType = visaType;
    additionalDocs.componentInstance.countryType = countryType;
    additionalDocs.componentInstance.submit = onSubmit;
  }

  public CandidateAdditionalDocReq(
    profile: CandidateProfile,
    onSubmit: (reqlist) => void
  ) {
    const additionalDocs = this.modalService.open(
      CandidateAdditionDocRequestComponent
    );
    additionalDocs.componentInstance.profile = profile;
    additionalDocs.componentInstance.submit = onSubmit;
  }
  public CandidatePendingDocReq(
    profile: CandidateProfile,
    onSubmit: (reqlist) => void
  ) {
    const pendingDocs = this.modalService.open(
      CandidatePendingDocRequestComponent
    );
    pendingDocs.componentInstance.profile = profile;
    pendingDocs.componentInstance.submit = onSubmit;
  }
  public EmpAdditionalDocReq(
    profile: EmployeeProfile,
    onSubmit: (reqlist) => void
  ) {
    const additionalDocs = this.modalService.open(
      EmpAdditionalDocRequestComponent
    );
    additionalDocs.componentInstance.profile = profile;
    additionalDocs.componentInstance.submit = onSubmit;
  }

  public showExitEmailPreview(
    mail: ExitEmailMessage,
    activity: ExitRequestActivity,
    exitRequest: ExitRequest,
    onSubmit: (mail) => void,
    fileUpload: (file) => Observable<any>,
    loadUploadedFiles: () => Observable<any>,
    deleteFile: (details) => Observable<any>,
    saveAsDraft: (draftedMail) => Observable<any>,
    templateAttchaments: () => Observable<any>
  ) {
    const mailModal = this.modalService.open(ConfigurableMailComponent);
    mailModal.componentInstance.showFileUploader = true;
    mailModal.componentInstance.submit = onSubmit;
    mailModal.componentInstance.fileUpload = fileUpload;
    mailModal.componentInstance.loadUploadedFiles = loadUploadedFiles;
    mailModal.componentInstance.deleteFile = deleteFile;
    mailModal.componentInstance.email = mail;
    mailModal.componentInstance.header = activity.header;
    mailModal.componentInstance.showAttachments = true;
    mailModal.componentInstance.showSaveDraft = true;
    mailModal.componentInstance.saveAsDraft = saveAsDraft;
    mailModal.componentInstance.headerControlAccess = ControlView.active;
    mailModal.componentInstance.candidate = exitRequest;
    mailModal.componentInstance.templateAttchaments = templateAttchaments;
  }

  public showLogDetails(logId: number) {
    const log = this.modalService.open(LogDetailsComponent);
    log.componentInstance.logId = logId;
  }
  public showNotificationDetails(userID: number) {
    const log = this.modalService.open(NotificationGridComponent);
    log.componentInstance.EmployeeID = userID;
  }
  public showTemplateDialog(
    email: EmailMessage,
    selectedTemplate: EmailTemplateEditorInfo
  ) {
    const log = this.modalService.open(TemplateSelectorComponent);
    log.componentInstance.email = email;
    log.componentInstance.searchparameter = selectedTemplate;
  }

  public showTimeoutWindow(readonly?: boolean) {
    const timeoutWindow = this.modalService.open(TimeoutWindowComponent);
    return timeoutWindow.result;
  }
  public showFlightBooking(
    candidateProfileId: number,
    model: PBProfile,
    steps: any,
    onOk: Function
  ) {
    const depFlightBookingWindow = this.modalService.open(DepFlightBookingComponent);
    depFlightBookingWindow.componentInstance.candidateId = candidateProfileId;
    depFlightBookingWindow.componentInstance.model = model;
    depFlightBookingWindow.componentInstance.step = steps;
    const updateSub = depFlightBookingWindow.componentInstance.updateComplete.subscribe((updatedModel) => {
      // Close the modal and pass the updated model to the onOk callback
      depFlightBookingWindow.close(updatedModel);
      updateSub.unsubscribe(); // Unsubscribe from the event
    });
  
    depFlightBookingWindow.result.then((resp) => {
      if (resp && onOk) {
        onOk(resp); // Pass the updated model to the onOk callback
      }
    });
    return depFlightBookingWindow.result;
  }
  public showHistory(
    candidateProfileId: number,
    model: CandidateProfile,
    module: "PB" | "IMM" | "RMT",
    visatype?: string,
    country?: string
  ) {
    const historyWindow = this.modalService.open(HistoryComponent);
    historyWindow.componentInstance.candidateId = candidateProfileId;
    historyWindow.componentInstance.model = model;
    historyWindow.componentInstance.module = module;
    historyWindow.componentInstance.visatype = visatype;
    historyWindow.componentInstance.country = country;
    return historyWindow.result;
  }

  public showExitHistory(
    requestId: number,
    model: ExitRequest,
    module: "EXT",
    exitType?: string
  ) {
    const historyWindow = this.modalService.open(HistoryComponent);
    historyWindow.componentInstance.candidateId = requestId;
    historyWindow.componentInstance.model = model;
    historyWindow.componentInstance.module = module;
    historyWindow.componentInstance.exitType = exitType;
    return historyWindow.result;
  }

  public showDateRangeFilter(
    filterparams: FilterParams,
    onSubmit: Function,
    header?: string
  ) {
    const DateRangeWindow = this.modalService.open(DateRangeFilterComponent);
    DateRangeWindow.componentInstance.startDate = filterparams.startDate;
    DateRangeWindow.componentInstance.endDate = filterparams.endDate;
    if (header && header.length) {
      DateRangeWindow.componentInstance.header = header;
    }

    DateRangeWindow.componentInstance.onSubmit = onSubmit;
  }

  public showDateRangeFilterSubmisionDate(
    filterparams: FilterParams,
    onSubmit: Function
  ) {
    const DateRangeWindow = this.modalService.open(DateRangeFilterComponent);
    DateRangeWindow.componentInstance.startDate =
      filterparams.submissionstartDate;
    DateRangeWindow.componentInstance.endDate = filterparams.submissionendDate;
    DateRangeWindow.componentInstance.header = "Select submission date range";
    DateRangeWindow.componentInstance.onSubmit = onSubmit;
  }

  public showPDFPreviewiew(url: string, filename = "") {
    const previewWindow = this.modalService.open(PdfViewerComponent);
    previewWindow.componentInstance.pdfSrc = url;
    previewWindow.componentInstance.title = filename;
    return previewWindow.result;
  }
  public showImagePreview(url: string, filename = "") {
    const previewWindow = this.modalService.open(ImageViewerComponent);
    previewWindow.componentInstance.imageSrc = url;
    previewWindow.componentInstance.title = filename;
    return previewWindow.result;
  }

  public showUserEdit(user: UserInfo, title: string, onAction: Function) {
    const userEditor = this.modalService.open(UserEditorComponent);
    userEditor.componentInstance.userInfo = user;
    userEditor.componentInstance.title = title;
    userEditor.componentInstance.OnAction = onAction;
    return userEditor.result;
  }

  public showActivityAmendEdit(activity: Activity, countries: LookupField[]) {
    const userEditor = this.modalService.open(TaskAmendmentEditComponent);
    userEditor.componentInstance.activity = activity;
    userEditor.componentInstance.countries = countries;
    return userEditor;
  }
  public showLookupAmendEdit(lookupField: LookupField, module: string) {
    const lookup = this.modalService.open(LookupTypeAmendmentEditComponent);
    lookup.componentInstance.lookupField = lookupField;
    lookup.componentInstance.isEdit = true;
    lookup.componentInstance.module = module;
    return lookup;
  }
  public showLookupAmendCreate(lookupTypeId: number, module: string) {
    const lookup = this.modalService.open(LookupTypeAmendmentEditComponent);
    lookup.componentInstance.lookUpTypeId = lookupTypeId;
    lookup.componentInstance.isEdit = false;
    lookup.componentInstance.module = module;
    return lookup;
  }

  public showActivityAmendCreate(
    employeeCategory: LookupField[],
    countries: LookupField[],
    preboardingTypes: LookupField[],
    activityTypes: any[],
    activity?: Activity,
    withinSameOffice = false
  ) {
    const userEditor = this.modalService.open(TaskAmendmentEditComponent);
    userEditor.componentInstance.activity = activity;
    userEditor.componentInstance.activityTypes = activityTypes;
    userEditor.componentInstance.isEdit = false;
    userEditor.componentInstance.employeeCategories = employeeCategory;
    userEditor.componentInstance.countries = countries;
    userEditor.componentInstance.preboardingTypes = preboardingTypes;
    userEditor.componentInstance.withinSameOffice = withinSameOffice;

    return userEditor;
  }

  public loadGenMail(
    model: any,
    onSubmit: (mail) => void,
    header: string = "Header",
    emailattachments: () => Observable<any>
  ) {
    const mailModal = this.modalService.open(ConfigurableMailComponent);
    mailModal.componentInstance.submit = onSubmit;
    mailModal.componentInstance.email = model;
    mailModal.componentInstance.header = header;
    mailModal.componentInstance.showAttachments = true;
    mailModal.componentInstance.templateAttchaments = emailattachments;
  }

  public docShareMail(
    model: any,
    onSubmit: (mail) => void,
    header: string = "Header",
    moduleType,
    isSingleShareDocs = false,
    mulShareDocs = []
  ) {
    const mailModal = this.modalService.open(ConfigurableMailComponent);
    mailModal.componentInstance.submit = onSubmit;
    mailModal.componentInstance.email = model;
    mailModal.componentInstance.header = header;
    mailModal.componentInstance.showAttachments = true;
    mailModal.componentInstance.ismultipleShareDocs = isSingleShareDocs
      ? false
      : true;
    mailModal.componentInstance.headerControlAccess = ControlView.active;
    mailModal.componentInstance.moduleType = moduleType;
    mailModal.componentInstance.isShareDocs = isSingleShareDocs;
    mailModal.componentInstance.mulShareDocs = mulShareDocs;
    mailModal.componentInstance.isDocShare = true;
  }
  public loadComment(
    getComments: () => Observable<any>,
    onSave: (comment: string) => Observable<any>,
    onUpdate: (commentObj: any) => Observable<any>,
    readonly = false
  ) {
    const commentModal = this.modalService.open(ConfigurableCommentComponent);
    commentModal.componentInstance.updateComment = onUpdate;
    commentModal.componentInstance.saveComment = onSave;
    commentModal.componentInstance.readonly = readonly;
    commentModal.componentInstance.getComments = getComments;
    commentModal.componentInstance.notEditableCommentType =
      ExitCommentTypes.Notes;
  }

  public loadPbMilestones(): NgbModalRef {
    const mailModal = this.modalService.open(MilestoneBasicComponent);
    return mailModal;
  }

  public showUserProfileHistory(gpn, gui) {
    const lookup = this.modalService.open(UserRequestComponent);
    lookup.componentInstance.gpn = gpn;
    lookup.componentInstance.gui = gui;
  }
  public showExitActivityEdit(
    activity: ExitRequestActivity,
    exitType: LookupField[],
    exitSubType: LookupField[],
    nationalityType: LookupField[],
    officeLocation: LookupField[],
    rank: LookupField[],
    isEdit: boolean
  ) {
    const exitAct = this.modalService.open(ExitTaskAmendEditComponent);
    exitAct.componentInstance.activity = activity;
    exitAct.componentInstance.exitTypes = exitType;
    exitAct.componentInstance.nationalityType = nationalityType;
    exitAct.componentInstance.exitSubTypes = exitSubType;
    exitAct.componentInstance.officeLocation = officeLocation;
    exitAct.componentInstance.rank = rank;
    exitAct.componentInstance.isEdit = isEdit;
    return exitAct;
  }

  public showImmDocumentVisamappingEdit(
    activity: ImmigrationDocumentVisaMappingDTO,
    countries: LookupField[],
    visaTypes: LookupField[],
    documentTypes: LookupField[],
    documentNames: LookupField[],
    isEdit: boolean,
    countryId : number,
    visaTypeId : number
  ) {
    const exitAct = this.modalService.open(ImmDocumentVisamappingEditComponent);
    exitAct.componentInstance.activity = activity;
    exitAct.componentInstance.countries = countries;
    exitAct.componentInstance.visaTypes = visaTypes;
    //exitAct.componentInstance.documentTypes = documentTypes.filter(
    //  (x) => x.parentCode === "IMM"
    //);
    exitAct.componentInstance.documentTypes = documentTypes;
    exitAct.componentInstance.documentNames = documentNames;
    exitAct.componentInstance.isEdit = isEdit;
    exitAct.componentInstance.countryId = countryId;
    exitAct.componentInstance.visaTypeId = visaTypeId;
    return exitAct;
  }

  public showMileStone(id: number, country: string) {
    const milestone = this.modalService.open(MilestoneComponent);
    milestone.componentInstance.id = id;
    milestone.componentInstance.country = country;
  }
  public showBulkUpload(
    onUpload: (invalidRecords: any, fileName, selectedDocument) => void
  ) {
    const uploadModal = this.modalService.open(ExitBulkUploadComponent);
    uploadModal.componentInstance.submit = onUpload;
  }

  public showBulkUploadConfirmationBox(
    invalidRecords: any,
    onUpload: (isUploaded) => void
  ) {
    const bulkAlertRef = this.modalService.open(
      BulkUploadConfirmationComponent
    );
    bulkAlertRef.componentInstance.invalidRecords = invalidRecords;
    bulkAlertRef.componentInstance.onUpload = onUpload;
  }

  public closeAllModal() {
    this.modalService.dismissAll();
  }

  public showPopUpMessage(
    content: string,
    onOk: Function,
    header: string = "",
    isPopUp = true
  ): void {
    const messageRef = this.modalService.open(AlertComponent, {
      windowClass: "PopUpModalClass",
    });
    messageRef.componentInstance.content = content;
    messageRef.componentInstance.header = header;
    messageRef.componentInstance.isPopUp = isPopUp;
    messageRef.result.then((resp) => {
      if (resp && onOk) {
        onOk();
      }
    });
  }

  public showTimelineReportBox(readonly?: boolean) {
    const comment = this.modalService.open(TimelineReportComponent, {
      windowClass: "TimelinePopUpModalClass",
    });
    //const comment = this.modalService.open(TimelineReportComponent);
  }

   public showPendingActionReportBox(readonly?: boolean) {
    const comment = this.modalService.open(PendingactionReportComponent, {
      windowClass: "TimelinePopUpModalClass",
    });
    //const comment = this.modalService.open(TimelineReportComponent);
  }
}
